<ph-dialog [open]="open" size="md" heading="Verify your Stripe account" dismissible="false" (ph-close)="close()">
    <ph-skeleton *ngIf="loading" shape="form" rows="4" stagger label="Loading verification form…"></ph-skeleton>

    <!-- Rejected before the form could load: Stripe refused the details we sent. -->
    <ph-alert *ngIf="rejectionReasons" status="error">
        <strong>{{ 'We could not start verification' }}</strong>
        <span *ngFor="let reason of rejectionReasons; trackBy: trackByIndex">{{ reason }}</span>
        <ph-link-button slot="action" variant="primary" size="small" (click)="goToOrganizationSettings()">{{ 'Review organization settings' }}</ph-link-button>
    </ph-alert>

    <!-- Hidden while loading, and when the create was rejected: the form never mounted, so leaving it
         visible reserves its height under the reason for nothing. -->
    <div #stripeContainer [hidden]="loading || !!rejectionReasons"></div>
</ph-dialog>
